var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"remove-from-compare",attrs:{"href":"javascript:;"},on:{"click":_vm.removeCompareItem}},[_c('img',{staticClass:"mCS_img_loaded",attrs:{"src":_vm.src,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }